import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, AbstractControl } from '@angular/forms';

export type FormFieldType =
  | 'text'
  | 'email'
  | 'password'
  | 'number'
  | 'tel'
  | 'url'
  | 'date'
  | 'textarea';

/**
 * FormField Component - Reusable form field with label and error handling
 *
 * @example
 * <app-atom-form-field
 *   label="Email Address"
 *   [required]="true"
 *   [control]="formGroup.get('email')"
 *   [submitted]="submitted"
 *   placeholder="Enter your email">
 *   <input formControlName="email" type="email" />
 * </app-atom-form-field>
 */
@Component({
  selector: 'app-atom-form-field',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
})
export class FormFieldComponent {
  // Inputs using Angular 19 signal-based inputs
  label = input<string>('');
  fieldId = input<string>('');
  required = input<boolean>(false);
  control = input<AbstractControl | null>(null);
  submitted = input<boolean>(false);
  hint = input<string>('');
  error = input<string | boolean>('');
  customError = input<string>('');
  wrapperClass = input<string>('');
  errorMessages = input<Record<string, string>>({});

  /**
   * Show errors if form is submitted and control has errors
   */
  showErrors(): boolean {
    return this.submitted() && !!this.control()?.errors;
  }
}
